<template>
  <div id="SnowWording"/>
</template>

<script setup>
import p5 from 'p5'
import {ref, reactive, watchEffect, onUnmounted, watch, onMounted} from 'vue'

import defaultValue from "@/utils/defaultValue"
import colorTool from "@/utils/colorTool"
import moment from "moment/moment";
import freeImg from "@/utils/freeImg";

const {defaultWidth, defaultHeight} = defaultValue()


const props = defineProps(['effectTheme', 'controlMode'])
const {changeToRgba255, getRgbFilterString} = colorTool()
const {freeImages} = freeImg()


const effectThemeData = reactive(props.effectTheme)
let canvasWrap = ref('stop')
let backgroundColor = ref('rgba(0,0,0,255)')
let backgroundColorArr = ref([0,0,0,255])
let imgUrl = ref(null)
let imagePathType = ref('')
let backgroundImage = ref('')
let drawPot = ref(0)

let nowDateTimeObj = reactive({obj: {}})
let timeTiger = ref(null)
function startTime() {
  if (timeTiger.value) clearTimeout(timeTiger.value)
  const nowDate = moment().format('MMM,DD,ddd,HH:mm,HH,mm,ss').split(',')
  const timeTextObj = {
    m: nowDate[0].toUpperCase(), // 月
    d: nowDate[1], // 日
    weekday: nowDate[2].toUpperCase(), // 星期
    time: nowDate[3], // 時間
    hour: nowDate[4],
    min: nowDate[5],
    sec: `${nowDate[6]}`
  }
  nowDateTimeObj.obj = timeTextObj
  timeTiger.value = setTimeout(function () {
    startTime()
  }, 150)
}

const snowWordingAnimate = (sketch) => {
  let cw = defaultWidth.value
  let ch = defaultHeight.value
  let pg_obj;
  let pg;
  let snowflakes = [];
  let img= [];
  let imgBg;
  let updatedTime = false;
  let updatedPgObj = false;
  let hr;
  let min;
  let t_showDateInfoMax = 7;
  let t_showDateInfo = t_showDateInfoMax + 1;
  let textSize = cw/5



  class Snowflake {
    constructor() {
      this.maxVel = 2;
      this.maxAccX= 0.3;
      this.maxAccY = 0.01;

      this.pos = sketch.createVector(sketch.int(sketch.random(sketch.width)), -sketch.int(sketch.random(50, sketch.height)));
      this.vel = sketch.createVector(sketch.random(-this.maxVel, this.maxVel), sketch.random(this.maxVel));
      this.acc = sketch.createVector(0, 0);
      this.vel_fric = sketch.createVector(sketch.random(-1, 1) * 0.03, 0.015);
      this.w_snow = sketch.random(3,8);
      this.alpha_snowMin = 100;
      this.alpha_snowMax = sketch.random(this.alpha_snowMin, 255);
      this.alpha_snow = this.alpha_snowMax;
      this.c_pause = '';
    }
    draw(_bgColor, _img) {
      this.c_pause = '';
      this.touchBoundary()
      if (this.pos.x < sketch.width && this.pos.y > 0 && this.pos.y < sketch.height) {
        this.c_pause = _img[sketch.int(this.pos.y) * sketch.width + sketch.int(this.pos.x)];
      } else {
        this.c_pause = _bgColor;
      }
      sketch.stroke(255, this.alpha_snow * 0.4);
      let isMove = this.c_pause && this.c_pause[0] === _bgColor[0] && this.c_pause[1] === _bgColor[1] && this.c_pause[2] === _bgColor[2] && this.c_pause[3] === _bgColor[3]
      if (isMove) {
        this.move();
        sketch.strokeWeight(this.w_snow * 0.8);
        sketch.point(this.pos.x, this.pos.y);

        sketch.strokeWeight(this.w_snow * 0.4);
        sketch.point(this.pos.x, this.pos.y);

      } else {
        this.pause();
        sketch.strokeWeight(this.w_snow);
        sketch.point(this.pos.x, this.pos.y);

        sketch.stroke(255, 230);
        sketch.strokeWeight(this.w_snow * 0.5);
        sketch.point(this.pos.x, this.pos.y);
      }
    }
    pause() {
      this.pos.add(this.vel_fric);
    }

    move() {
      this.vel.add(this.acc);
      this.vel.limit(this.maxVel);
      this.pos.add(this.vel);
      this.acc.x = sketch.random(-1, 1) * this.maxAccX;
      this.acc.y = sketch.random(this.maxAccY);
    }
    reset() {
      this.pos.x = sketch.int(sketch.random(sketch.width));
      this.pos.y = -10;
      this.vel.y = sketch.random(this.maxVel);
    }

    touchBoundary() {
      if (this.pos.y > sketch.height + 5) this.reset();
      if (this.pos.x < 0) {
        this.pos.x = sketch.width;
      } else if (this.pos.x > sketch.width) {
        this.pos.x = 0;
      }
    }

}



  sketch.setup = () => {
    sketch.createCanvas(cw, ch);
    sketch.frameRate(50);
    sketch.background(backgroundColorArr.value);
    sketch.noStroke();
    pg_obj = sketch.createGraphics(sketch.width, sketch.height);
    pg_obj.pixelDensity(1)
    let snowflakesLength = sketch.int(sketch.width * 2);
    for (let i  = 0; i < snowflakesLength; i++) {
      snowflakes.push(new Snowflake());
    }
    if (
        imagePathType.value !== 'gif' &&
        imagePathType.value !== 'mp4' &&
        imagePathType.value !== 'webm' &&
        imgUrl.value &&
        imgUrl.value !== null &&
        imgUrl.value !== ''
    ) imgBg = sketch.loadImage(imgUrl.value)
  }

  sketch.draw = () => {
    drawPot.value++
    sketch.background(backgroundColorArr.value);
    sketch.noStroke();

    if (
        imagePathType.value !== 'gif' &&
        imagePathType.value !== 'mp4' &&
        imagePathType.value !== 'webm' &&
        imgUrl.value &&
        imgUrl.value !== null &&
        imgUrl.value !== ''
    ) sketch.image(imgBg, 0, 0, sketch.width, sketch.height)

    if (t_showDateInfo < t_showDateInfoMax) {
      t_showDateInfo += 1/sketch.frameRate;
      updatedPgObj = false;
    } else {
      if (!updatedPgObj) {
        updatePgObj();
        updatePg();
        updatedPgObj = true;
      }
    }

      if (
          sketch.str(nowDateTimeObj.obj.hour) !== sketch.str(hr) ||
          sketch.str(nowDateTimeObj.obj.min) !== sketch.str(min)
      ) {
      updateTime();
      updatePg();
    }


    // draw snowflakes
    for (let i  = 0; i < snowflakes.length; i++) {
      snowflakes[i].draw(backgroundColorArr.value, img);
    }

  }

  function updateTime() {
    hr = nowDateTimeObj.obj.hour;
    min = nowDateTimeObj.obj.min;
    updatedTime = true;
  }
   function updatePg() {
    pg = sketch.createGraphics(sketch.width, sketch.height)
    pg.pixelDensity(1)
    pg.image(pg_obj, 0,0)
    pg.fill(255);
    pg.textAlign(sketch.CENTER);
    pg.textSize(textSize);
    pg.text(nowDateTimeObj.obj.hour + " : " + nowDateTimeObj.obj.min, pg.width/2, pg.height/2 + 20);
     pg.loadPixels()

     for (let y2 = 0; y2 < pg.height; y2++) {
       for (let x2 = 0; x2 < pg.width; x2++) {
         img[y2*pg.width+x2] = pg.get(x2,y2);
       }
     }
     pg.remove()
   }

  function updatePgObj() {
    pg_obj.background(backgroundColorArr.value);
  }
}

function initAnimate () {
  if (canvasWrap.value !== 'stop') {
    canvasWrap.value.remove()
    canvasWrap.value = 'stop'
  }
}

// watch(drawPot, (n, o) => {
//   if (n > 300) {
//     initAnimate()
//     canvasWrap.value = new p5(snowWordingAnimate, 'SnowWording')
//     drawPot.value = 0
//   }
// })

watchEffect(() => {
  if (timeTiger.value) clearTimeout(timeTiger.value)
  startTime()

  const {
    BackgroundColor,
    BackgroundImage
  } = effectThemeData

  let bgColor = typeof BackgroundColor === "object" && BackgroundColor.length > 0 ? changeToRgba255(BackgroundColor) : 'rgba(0,0,0,255)'

  // 背景色, 背景圖 需 重置動畫
  if (
      backgroundImage.value !== BackgroundImage ||
    backgroundColor.value !== bgColor
  ) {

    imagePathType.value = ''
    backgroundImage.value = BackgroundImage
    backgroundColor.value = bgColor
    let arr = getRgbFilterString(bgColor)
    backgroundColorArr.value = [ parseInt(arr[0]),parseInt(arr[1]), parseInt(arr[2]), parseInt(arr[3])]
    if (backgroundImage.value !== '') {
      if (props.controlMode && props.controlMode.toString() === 'true') {
        const pathSplit = backgroundImage.value.split('.')
        imgUrl.value = freeImages[pathSplit[0]]
        imagePathType.value = pathSplit[1]
      } else {
        imgUrl.value = backgroundImage.value.split('#')[0]
        if (imgUrl.value.endsWith('.mp4')) imagePathType.value = 'mp4'
        else if (imgUrl.value.endsWith('.webm')) imagePathType.value = 'webm'
        else if (imgUrl.value.endsWith('.gif')) imagePathType.value = 'gif'
      }
    }
    if (backgroundImage.value === '') {
      imgUrl.value = ''
      imagePathType.value = ''
    }
    // create p5
    if (canvasWrap.value !== 'stop') {
      initAnimate()
      canvasWrap.value = new p5(snowWordingAnimate, 'SnowWording')
    }
  }

})

onMounted(() => {
  if (canvasWrap.value === 'stop') canvasWrap.value = new p5(snowWordingAnimate, 'SnowWording')
})

onUnmounted(() => {
  drawPot.value = 0
  backgroundColor.value = 'rgba(0,0,0,255)'
  initAnimate()
  if (timeTiger.value) clearTimeout(timeTiger.value)

})

</script>
